import { createGlideGenerator } from './generator.es.js';
import { createGeneratorEasing } from '../utils/create-generator-easing.es.js';
var glide = createGeneratorEasing(createGlideGenerator);
export { glide };